import { PageContainer } from '@/components/layout';
import { HeroSection } from '@/components/home/HeroSection';
import { MetricGroupsSection } from '@/components/home/MetricGroupsSection';
import { WhatsNewFeed } from '@/components/home/WhatsNewFeed';
import { WhatsComingFeed } from '@/components/home/WhatsComingFeed';

export function HomePage() {
  return (
    <PageContainer variant="wide" className="space-y-6 p-6">
      <HeroSection />
      <MetricGroupsSection />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <WhatsNewFeed />
        <WhatsComingFeed />
      </div>
    </PageContainer>
  );
}
